package org.example.zone360.models

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlinx.serialization.json.JsonElement

@Serializable
data class CommonDataResponse(
    val response: String = "",
    val error: String = "",
)
@Serializable
data class ChatBotMessage(
    val message: String = "",           // full content — ALWAYS used for history/payload
    val displayMessage: String? = null, // optional short label shown in UI instead of `message
    val isUserMessage: Boolean = false,

    // Stream UI state
    val status: String = "",          // Thinking..., Searching..., etc.
    val isThinking: Boolean = false,
    val isStreaming: Boolean = false,


    val pdfPayload: JsonElement? = null,
    val pdfType: String? = null
)

@Serializable
data class ChatBtResponse(
    val reply: String,
    @SerialName("session_id")
    val sessionId: String,
)

//======== coach chat bot==================//

@Serializable
data class CoachChatBotResponse(
    val summary: String
)

@Serializable
data class ChatBotData(
    val _attachments: String,
    val _etag: String,
    val _rid: String,
    val _self: String,
    val _ts: Long,
    val accessToken: String,
    val count: Int,
    val dob: String,
    val donut: Donut,
    val email: String,
    val emphais: String,
    val fcmToken: String,
    val firstName: String,
    val id: String,
    val imageUrl: String,
    val isVerified: String,
    val job: String,
    val lastName: String,
    val level: String,
    val nationality: String,
    val organization: String,
    val organization1: String,
    val recordTime: Long,
    val role: String,
    val speakingTime: Double,
    val teams: List<String>,
    val totalKeywords: Int,
    val type: String,
    val uid: String,
    val verificationCode: String
)

@Serializable
data class Donut(
    val fitness: Int,
    val goalkeeper: Int,
    val mental: Int,
    val tactical: Int,
    val technical: Int
)

@Serializable
data class AdminBotResponse(
    val type: String,
    val content: String? = null,
    val summary: String? = null,
    val pdfPayload: JsonElement? = null,
    val pdfType: String? = null,
    val round: Int? = null,
    val name: String? = null
)


